import { Button } from 'antd'
import { PageHeader } from 'components/PageHeader'
import styled from 'styled-components'

export const StyledPageHeader = styled(PageHeader)`
  margin-bottom: 1rem;
`

export const NavigationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-left: auto;
`

export const NavigationButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background: ${({ theme }) => theme.forecast.background2};
  border: none;
  color: ${({ theme }) => theme.forecast.activeText};

  &:hover {
    background: ${({ theme }) => theme.forecast.background3};
    color: ${({ theme }) => theme.forecast.activeText};
  }

  &:disabled {
    background: ${({ theme }) => theme.forecast.background2};
    color: ${({ theme }) => theme.forecast.tertiaryText};
  }
`

export const DetailsContainer = styled.div`
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  overflow-y: auto;
  padding: 1rem 0 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 0;
`

export const InfoRow = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 0.5rem;
  color: ${({ theme }) => theme.forecast.activeText};
`

export const InfoLabel = styled.span`
  font-weight: 500;
  min-width: 100px;
  color: ${({ theme }) => theme.forecast.defaultText};
`

export const DetailsOuterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  max-width: 100vw;
  min-height: 100vh;
  height: 100vh;
  overflow: hidden;
  padding-bottom: 3rem;
`

export const DetailsInnerContainer = styled.div`
  display: flex;
  padding: 0 1rem;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  margin-bottom: 0;
  overflow: hidden;
`
